import device from '@/utils/device'
import env from '@/utils/env'
import localStorage from '@/utils/localStorage'
import hlid from '@/DATA/hlid.js';

function getHlid( ptid ) {
  let result;

  if ( ptid ) {
    result = hlid.web[ ptid ] || hlid.web.others;
  } else if ( env.isQuickApp ) {
    result = hlid.quickApp[ env.quickappBrand ] || hlid.quickApp.others;
  } else if ( env.isNative ) {
    result = hlid.native[ env.appName ] || hlid.native.gtgj;
  } else {
    result = hlid.web.others;
  }

  return result;
}

// localStorage.set('ptid', 'sa')

const queryString = require('query-string');

const parsed = queryString.parse(location.search);
const ptid   = localStorage.get('ptid') || parsed.ptid || '';

const DEFAULT_PARAMS = {
  client     : 'vuetrainweb',
  source     : 'vuetrainweb',
  platform   : 'web',
  cver       : '7.0',
  dver       : '0',
  iver       : '5.32',
  format     : 'json',
  hlsecret   : '3p5C26iD',
  projectver : '1.0',
  modulecver : '7.0',
  hlid       : getHlid( ptid ),

  hlp : JSON.stringify( {
    operasys           : env.os,
    sysver             : env.osVersion,
    device             : env.device.model,
    devicetype         : 'web',
    linkmode           : 'wifi',
    module             : 'gtgj',
    analyseSourceEntry : parsed.analyseSourceEntry || '',
    root               : '0',

    screen : [
      env.screen.width, env.screen.height, env.screen.pixelRatio
    ].join( ',' ),
  } )
}

// 根据渠道参数及推广参数，修改默认系统参数
/* global HLCX_PARTNER_SOURCE */
if (window[HLCX_PARTNER_SOURCE]) {
  DEFAULT_PARAMS.source = window[HLCX_PARTNER_SOURCE]
}

/* global HLCX_ENTRY_SOURCE */
if (window[HLCX_ENTRY_SOURCE]) {
  DEFAULT_PARAMS.analyseSourceEntry = window[HLCX_ENTRY_SOURCE]
}

const p = [
  ptid || DEFAULT_PARAMS.source,
  env.os,
  DEFAULT_PARAMS.client,
  DEFAULT_PARAMS.cver,
  DEFAULT_PARAMS.platform
].join(',')

const defaultParams = device.get().then(d => {
  return Object.assign({}, {
    ...DEFAULT_PARAMS,
    uid: d.uid,
    // imei: d.imei,
    uuid: d.uuid,
    p,
    appinfo: d.p || p,
  },
  ptid ? {
    source: ptid
  } : {}
  )
})

export default function getCommonParams() {
  return defaultParams.then(params => {
    return Object.assign({
      ...params,
      systemtime: new Date().getTime()
    }, env.quickBrandSource ? {
      ai_from: env.quickBrandSource
    } : {})
  })
}



// WEBPACK FOOTER //
// ./src/utils/getCommonRequestParams.js